import { styled } from "@mui/material/styles";

import theme from "@/theme";

export const StyledHtml = styled("div")`
  width: 100%;
  margin-bottom: 1em;
  overflow: auto;
  font-family: "RO", Arial, sans-serif !important;

  p,
  ul,
  ol,
  li,
  dl,
  dt,
  dd,
  span {
    font-size: 1em;
    font-weight: normal;
    margin: 0;
    padding: 0;
  }
  div {
    font-size: 1em;
    font-weight: normal;
    &.meta {
      font-size: 0.875em;
    }
  }
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    margin-top: 0.5em;
    margin-bottom: 0.5em;
  }

  p {
    margin: 1em 0;
    word-wrap: break-word;
  }

  > ul,
  ol {
    margin: 1em 0 1em 0em;
    list-style-type: none;
  }

  > ul ul {
    margin: 1em 0 1em 1em;
    list-style-type: disc;
  }

  > ul ul ul {
    margin: 0;
    margin: 1em 0 1em 1em;
  }

  > ul ul ul ul {
    margin: 0;
  }

  ul a {
    color: #01689b;
  }

  code,
  pre code {
    display: block;
    font-size: 0.875rem;
  }

  img {
    max-width: 100%;
  }

  blockquote {
    margin: 0 0 1rem;
    padding: 0.625rem 1.3888888889rem 0 1.3194444444rem;
    border-left: 1px solid #cacaca;
  }

  blockquote,
  blockquote p {
    line-height: 1.6;
    color: #8a8a8a;
  }

  table {
    width: 100%;
    margin: 0.5em 0;
    border-collapse: collapse;

    td,
    th {
      text-align: left;
      padding: 0.1em 0.25em;
    }

    th {
      font-weight: bold;
    }

    tbody th {
      text-align: left;
      font-style: italic;
    }

    thead {
      background-color: #f3f3f3;
      th,
      td {
        font-weight: bold;
        padding: 0.25em;
      }
    }

    thead tr th:last-child {
      padding-right: 10px;
    }

    tbody tr td:last-child {
      padding-right: 10px;
    }

    select {
      margin: 2px;
      font-weight: normal;
    }
  }

  strong {
    font-weight: bold;
  }

  dl {
    margin-bottom: 0.5em;
    dt {
      font-weight: bold;
    }
  }

  pre {
    float: left;
    width: 100%;
    font-size: 0.55em;
    overflow: auto;
  }

  code {
    border: 1px solid #cacaca;
    background-color: #e6e6e6;
    font-family: Consolas, "Liberation Mono", Courier, monospace;
    font-weight: normal;
    color: #0a0a0a;
    display: inline;
    max-width: 100%;
    word-wrap: break-word;
    padding: 0.1388888889rem 0.3472222222rem 0.0694444444rem;
  }

  div.rubriekkop {
    display: none;
  }
  div.hoofdkop {
    display: none;
  }
  div.subkop {
    font-weight: 900;
  }
  div.alineakop {
    margin-top: 1em;
    font-weight: 900;
  }

  div.choices__list--dropdown {
    margin-top: -2px;
  }

  div.choices__inner {
    padding: 0.555rem;
  }

  // form styling in html
  form {
    label {
      color: #3a3a3a;
      display: block;
      font-size: 0.75em;
      float: left;
      text-align: left;
      width: 100%;
    }

    select {
      appearance: none;
      background-color: white;
      background-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' version='1.1' width='32' height='24' viewBox='0 0 32 24'><polygon points='0,0 32,0 16,24' style='fill: rgb%28138, 138, 138%29'></polygon></svg>");
      background-origin: content-box;
      background-position: right -1.111111rem center;
      background-repeat: no-repeat;
      background-size: 9px 6px;
      border: 1px solid #cacaca;
      border-radius: 3px;
      line-height: 1.5rem;
      padding: 0.555em;
      padding-right: 1.66666rem;
      margin-bottom: 1.11111rem;
      width: 100%;
    }

    .button {
      border: 1px solid transparent;
      color: white;
      display: inline-block;
      font-size: 0.9em;
      margin: 0;
      margin-bottom: 1rem;
      padding: 0.85em 1em;
      cursor: pointer;
      background: ${theme.palette.primary.main};
      transition: background 0.3s ease;
    }

    .button:hover {
      background: ${theme.palette.primary.dark};
    }

    fieldset {
      border: 0;
      float: left;
      margin: 0;
      padding: 0.7em 0;
      width: 100%;
    }

    fieldset.callout {
      background: #f3f3f3;
      display: inline-block;
      margin-bottom: 1em;
      padding: 1rem;
      position: relative;
      width: 100%;
    }

    legend {
      border-bottom: 3px solid #dedede;
      clear: both;
      float: left;
      font-size: 1.1em;
      font-weight: 600;
      margin-bottom: 0.555555rem;
      width: 100%;
    }

    fieldset fieldset legend {
      border-bottom: 1px solid #dedede;
      font-size: 1em;
      font-weight: 400;
    }

    input[type="checkbox"],
    input[type="radio"] {
      margin: 0 0 1.111111rem;
    }

    label > input[type="checkbox"],
    label > input[type="radio"] {
      margin-right: 0.555555rem;
    }

    .input-options {
      clear: both;
      display: flex;
    }

    .row {
      display: grid;
      gap: 1rem;
      grid-template-columns: 1fr;

      @media print, screen and (min-width: 41.875em) {
        grid-template-columns: repeat(4, 1fr);
      }
    }
  }

  // Extra classes used in legacy opmet HTML
  .bg-color-FFFFFF {
    background-color: #ffffff;
  }
  .bg-color-FFFF88 {
    background-color: #ffff88;
  }
  .bg-color-FFFF00 {
    background-color: #ffff00;
  }
  .bg-color-FFEE00 {
    background-color: #ffee00;
  }
  .bg-color-FFDD00 {
    background-color: #ffdd00;
  }
  .bg-color-FFCC00 {
    background-color: #ffcc00;
  }
  .bg-color-FFBB00 {
    background-color: #ffbb00;
  }
  .bg-color-FFAA00 {
    background-color: #ffaa00;
  }
  .bg-color-FF9900 {
    background-color: #ff9900;
  }
  .bg-color-FF8800 {
    background-color: #ff8800;
  }
  .bg-color-FF7700 {
    background-color: #ff7700;
  }
  .bg-color-FF6600 {
    background-color: #ff6600;
  }
  .bg-color-FF5500 {
    background-color: #ff5500;
  }
  .bg-color-FF4400 {
    background-color: #ff4400;
  }
  .bg-color-FF3300 {
    background-color: #ff3300;
  }
  .bg-color-FF2200 {
    background-color: #ff2200;
  }
  .bg-color-FF1100 {
    background-color: #ff1100;
  }
  .bg-color-FF0000 {
    background-color: #ff0000;
  }
  .bg-color-DD0000 {
    background-color: #dd0000;
  }
  .bg-color-FFFFFF {
    background-color: #ffffff;
  }

  .fg-color-FFFFFF {
    color: #ffffff;
  }
  .fg-color-000000 {
    color: #000000;
  }

  td[title="000 deg"] {
    transform: rotate(00deg);
  }
  td[title="010 deg"] {
    transform: rotate(10deg);
  }
  td[title="020 deg"] {
    transform: rotate(20deg);
  }
  td[title="030 deg"] {
    transform: rotate(30deg);
  }
  td[title="040 deg"] {
    transform: rotate(40deg);
  }
  td[title="050 deg"] {
    transform: rotate(50deg);
  }
  td[title="060 deg"] {
    transform: rotate(60deg);
  }
  td[title="070 deg"] {
    transform: rotate(70deg);
  }
  td[title="080 deg"] {
    transform: rotate(80deg);
  }
  td[title="090 deg"] {
    transform: rotate(90deg);
  }
  td[title="100 deg"] {
    transform: rotate(100deg);
  }
  td[title="110 deg"] {
    transform: rotate(110deg);
  }
  td[title="120 deg"] {
    transform: rotate(120deg);
  }
  td[title="130 deg"] {
    transform: rotate(130deg);
  }
  td[title="140 deg"] {
    transform: rotate(140deg);
  }
  td[title="150 deg"] {
    transform: rotate(150deg);
  }
  td[title="160 deg"] {
    transform: rotate(160deg);
  }
  td[title="170 deg"] {
    transform: rotate(170deg);
  }
  td[title="180 deg"] {
    transform: rotate(180deg);
  }
  td[title="190 deg"] {
    transform: rotate(190deg);
  }
  td[title="200 deg"] {
    transform: rotate(200deg);
  }
  td[title="210 deg"] {
    transform: rotate(210deg);
  }
  td[title="220 deg"] {
    transform: rotate(220deg);
  }
  td[title="230 deg"] {
    transform: rotate(230deg);
  }
  td[title="240 deg"] {
    transform: rotate(240deg);
  }
  td[title="250 deg"] {
    transform: rotate(250deg);
  }
  td[title="260 deg"] {
    transform: rotate(260deg);
  }
  td[title="270 deg"] {
    transform: rotate(270deg);
  }
  td[title="280 deg"] {
    transform: rotate(280deg);
  }
  td[title="290 deg"] {
    transform: rotate(290deg);
  }
  td[title="300 deg"] {
    transform: rotate(300deg);
  }
  td[title="310 deg"] {
    transform: rotate(310deg);
  }
  td[title="320 deg"] {
    transform: rotate(320deg);
  }
  td[title="330 deg"] {
    transform: rotate(330deg);
  }
  td[title="340 deg"] {
    transform: rotate(340deg);
  }
  td[title="350 deg"] {
    transform: rotate(350deg);
  }
  td[title="360 deg"] {
    transform: rotate(360deg);
  }
  td[title$=" deg"] {
    text-align: center;
  }

  td.c1 {
    font-weight: bold;
    text-align: left;
  }
  td.c1 span {
    padding: 0.3em 0.6em;
    margin: 0 0.3em;
  }

  .button {
    cursor: pointer;
  }
`;
